import { ChangeDetectorRef, Component, Input, NgZone, OnDestroy, inject } from '@angular/core';
import { copyText } from 'src/app/utils/utils';
import { CdsIconModule } from '@cds/ng-web-components/icon';

@Component({
  selector: 'app-copy-button',
  templateUrl: './copy-button.component.html',
  styleUrls: ['./copy-button.component.scss'],
  imports: [CdsIconModule],
})
export class CopyButtonComponent implements OnDestroy {
  private readonly zone = inject(NgZone, { optional: true }) ?? ({ run: <T>(fn: () => T) => fn() } as NgZone);
  private readonly cdr = inject(ChangeDetectorRef, { optional: true }) ?? ({ detectChanges: () => undefined } as ChangeDetectorRef);

  @Input() value = '';
  isShowCopied = false;
  private hideCopiedTimeoutId?: number;

  copy() {
    if (this.isShowCopied) {
      return;
    }
    copyText(this.value);
    this.isShowCopied = true;
    this.hideCopiedTimeoutId = window.setTimeout(() => {
      this.zone.run(() => {
        this.isShowCopied = false;
        this.cdr.detectChanges();
      });
      this.hideCopiedTimeoutId = undefined;
    }, 2000);
  }

  ngOnDestroy(): void {
    if (this.hideCopiedTimeoutId !== undefined) {
      window.clearTimeout(this.hideCopiedTimeoutId);
    }
  }
}
